/* eslint-disable max-lines */
import aSubStatus from '@lba-dev/package.local-globals/aSubStatus';
import categories from '@lba-dev/package.local-globals/categories';
import status from '@lba-dev/package.local-globals/iStatus';
import { data as paidStatus } from '@lba-dev/package.local-globals/paidStatus';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import {
  S_BTOB,
  S_INT,
  S_DEVIS,
  S_ACHAT,
  S_PART,
  S_SATCL,
  S_JUR,
  S_INFO,
} from '@lba-dev/package.local-globals/services';

import { Types } from './Types';
import sourceLogoArtisans from '../sourceLogoArtisans';
import { artisanKeys } from '../function';

export const addColumnsByService = (
  service, { users, user }
) => {
  switch (service) {
    case S_BTOB: {
      const columns = {
        table: {
          OS: Types.Text,
          Telepro: Types.Text,
          'Cat.': Types.Rectangle,
          Ajout: Types.Text,
          Client: Types.Text,
          Ville: Types.Text,
          Artisan: Types.artisanRef,
          Prevu: Types.Date,
          Prix: Types.Money,
          iStatus: Types.Chip,
          rSST: Types.Chip,
          'Grand Compte': Types.nomGramdCompte,
          Appel: Types.Icon,
        },
        tableData: [
          { class: 'th' },
          { class: '', list: users, key: 'login' },
          { class: '', list: categories.data },
          { class: 'reduce' },
          { class: '' },
          { class: '', name: 'ville' },
          {
            class: 'th',
            name: 'artisan',
            list: [],
            key: 'currentArtisan.subStatus',
            status: aSubStatus.data,
            logoArtisan: sourceLogoArtisans,
            sourceArtisan: 'currentArtisan.source',
          },
          { class: 'reduce' },
          { class: '', key: 'onSitePayment' },
          { class: '', list: status.data },
          {
            class: '',
            name: 'firstPaid',
            key: 'firstPaid',
            list: paidStatus,
          },
          {
            class: 'th',
            name: 'grandCompte',
            list: [],
            key: 'billing.grandCompte',
          },
          { class: '' },
        ],
        keys: [
          'id',
          'login.ajout',
          'categorie',
          'date.ajout',
          [
            'client.civility',
            'client.name',
            'client.firstname',
            'client.society',
          ],
          ['client.address.zipcode', 'client.address.city'],
          artisanKeys(user),
          'date.intervention',
          'announcedPrice',
          'status',
          'firstPaid',
          'billing.grandCompte',
          'appel',
        ],
        checkType: [
          'number',
          'users',
          'categorie',
          'date',
          ['client.civility', 'client.name', 'client.firstname'],
          ['client.address.city', 'client.address.zipcode'],
          artisanKeys(user),
          'date',
          'prix',
          'iStatus',
          'number',
          'billing.grandCompte',
          'appel',
        ],
      };
      return columns;
    }
    case S_SATCL:
    case S_DEVIS: {
      const columns = {
        table: {
          OS: Types.Text,
          Telepro: Types.Text,
          Envoi: Types.Text,
          'Cat.': Types.Rectangle,
          Ajout: Types.Text,
          Client: Types.Text,
          Ville: Types.Text,
          Description: Types.StepMetierName,
          Artisan: Types.artisanRef,
          Prevu: Types.Date,
          Prix: Types.Money,
          iStatus: Types.Chip,
          Points: Types.Points,
          'Qualité support': Types.SupportPoints,
          rSST: Types.Chip,
          Appel: Types.Icon,
        },
        tableData: [
          { class: 'th' },
          { class: '', list: users, key: 'login' },
          { class: '', list: users, key: 'login' },
          { class: '', list: categories.data },
          { class: 'reduce' },
          { class: '' },
          { class: '', name: 'ville' },
          { class: '' },
          {
            class: 'th',
            name: 'artisan',
            list: [],
            key: 'currentArtisan.subStatus',
            status: aSubStatus.data,
            logoArtisan: sourceLogoArtisans,
            sourceArtisan: 'currentArtisan.source',
          },
          { class: 'reduce' },
          { class: '', key: 'onSitePayment' },
          { class: '', list: status.data },
          { class: '' },
          { class: '' },
          {
            class: '',
            name: 'firstPaid',
            key: 'firstPaid',
            list: paidStatus,
          },
          { class: '' },
        ],
        keys: [
          'id',
          'login.ajout',
          'login.envoi',
          'categorie',
          'date.ajout',
          [
            'client.civility',
            'client.name',
            'client.firstname',
            'client.society',
          ],
          ['client.address.zipcode', 'client.address.city'],
          'metierName',
          artisanKeys(user),
          'date.intervention',
          'announcedPrice',
          'status',
          'points',
          'qualite',
          'firstPaid',
          'appel',
        ],
        checkType: [
          'number',
          'users',
          'users',
          'categorie',
          'date',
          ['client.civility', 'client.name', 'client.firstname'],
          ['client.address.city', 'client.address.zipcode'],
          'metierName',
          artisanKeys(user),
          'date',
          'prix',
          'iStatus',
          'points',
          'qualite',
          'number',
          'appel',
        ],
      };
      return columns;
    }
    case S_INT: {
      const columns = {
        table: {
          OS: Types.Text,
          Telepro: Types.Text,
          Envoi: Types.Text,
          ...(permit(user) ? { Service: Types.ServiceName } : {}),
          'Cat.': Types.Rectangle,
          Ajout: Types.Text,
          Client: Types.Text,
          Ville: Types.Text,
          Description: Types.StepMetierName,
          Artisan: Types.artisanRef,
          Prevu: Types.Date,
          Prix: Types.Money,
          iStatus: Types.Chip,
          Appel: Types.Icon,
          Points: Types.Points,
          rSST: Types.Chip,
          'Mode de paiement': Types.CBPayment,
        },
        tableData: [
          { class: 'th' },
          { class: '', list: users, key: 'login' },
          { class: '', list: users, key: 'login' },
          ...(permit(user) ? [{ class: '' }] : []),
          { class: '', list: categories.data },
          { class: 'reduce' },
          { class: '' },
          { class: '', name: 'ville' },
          { class: '' },
          {
            class: 'th',
            name: 'artisan',
            list: [],
            key: 'currentArtisan.subStatus',
            status: aSubStatus.data,
            logoArtisan: sourceLogoArtisans,
            sourceArtisan: 'currentArtisan.source',
          },
          { class: 'reduce' },
          { class: '', key: 'onSitePayment' },
          { class: '', list: status.data },
          { class: '' },
          { class: '' },
          {
            class: '',
            name: 'firstPaid',
            key: 'firstPaid',
            list: paidStatus,
          },
          { class: '', key: 'cbPayment' },
        ],
        keys: [
          'id',
          'login.ajout',
          'login.envoi',
          ...(permit(user) ? ['service.desc'] : []),
          'categorie',
          'date.ajout',
          [
            'client.civility',
            'client.name',
            'client.firstname',
            'client.society',
          ],
          ['client.address.zipcode', 'client.address.city'],
          'metierName',
          artisanKeys(user),
          'date.intervention',
          'announcedPrice',
          'status',
          'appel',
          'points',
          'firstPaid',
          'cbPayment',
        ],
        checkType: [
          'number',
          'users',
          'users',
          ...(permit(user) ? ['service'] : []),
          'categorie',
          'date',
          ['client.civility', 'client.name', 'client.firstname'],
          ['client.address.city', 'client.address.zipcode'],
          'metierName',
          artisanKeys(user),
          'date',
          'prix',
          'iStatus',
          'appel',
          'points',
          'number',
          'cbPayment',
        ],
      };
      return columns;
    }
    case S_PART: {
      const columns = {
        table: {
          OS: Types.Text,
          Telepro: Types.Text,
          Envoi: Types.Text,
          'Cat.': Types.Rectangle,
          Equipe: Types.Equipe,
          Ajout: Types.Text,
          Client: Types.Text,
          Ville: Types.Text,
          Description: Types.StepMetierName,
          Artisan: Types.artisanRef,
          Prevu: Types.Date,
          Prix: Types.Money,
          iStatus: Types.Chip,
          rSST: Types.Chip,
          Appel: Types.Icon,
        },
        tableData: [
          { class: 'th' },
          { class: '', list: users, key: 'login' },
          { class: '', list: users, key: 'login' },
          { class: '', list: categories.data },
          { class: '' },
          { class: 'reduce' },
          { class: '' },
          { class: '', name: 'ville' },
          { class: '' },
          {
            class: 'th',
            name: 'artisan',
            list: [],
            key: 'currentArtisan.subStatus',
            status: aSubStatus.data,
            logoArtisan: sourceLogoArtisans,
            sourceArtisan: 'currentArtisan.source',
          },
          { class: 'reduce' },
          { class: '', key: 'onSitePayment' },
          { class: '', list: status.data },
          {
            class: '',
            name: 'firstPaid',
            key: 'firstPaid',
            list: paidStatus,
          },
          { class: '' },
        ],
        keys: [
          'id',
          'login.ajout',
          'login.envoi',
          'categorie',
          'equipe.client.address.zipcode',
          'date.ajout',
          [
            'client.civility',
            'client.name',
            'client.firstname',
            'client.society',
          ],
          ['client.address.zipcode', 'client.address.city'],
          'metierName',
          artisanKeys(user),
          'date.intervention',
          'announcedPrice',
          'status',
          'firstPaid',
          'appel',
        ],
        checkType: [
          'number',
          'users',
          'users',
          'categorie',
          'equipeAreasClient',
          'date',
          ['client.civility', 'client.name', 'client.firstname'],
          ['client.address.city', 'client.address.zipcode'],
          'metierName',
          artisanKeys(user),
          'date',
          'prix',
          'iStatus',
          'number',
          'appel',
        ],
      };
      return columns;
    }
    case S_ACHAT: {
      const columns = {
        table: {
          OS: Types.Text,
          Telepro: Types.Text,
          Rappel: Types.Date,
          'Cat.': Types.Rectangle,
          Ajout: Types.Text,
          Client: Types.Text,
          Ville: Types.Text,
          Description: Types.StepMetierName,
          Artisan: Types.artisanRef,
          Prevu: Types.Date,
          Prix: Types.Money,
          iStatus: Types.Chip,
        },
        tableData: [
          { class: 'th' },
          { class: '', list: users, key: 'login' },
          { class: 'reduce' },
          { class: '', list: categories.data },
          { class: 'reduce' },
          { class: '' },
          { class: '', name: 'ville' },
          { class: '' },
          {
            class: 'th',
            name: 'artisan',
            list: [],
            key: 'currentArtisan.subStatus',
            status: aSubStatus.data,
            logoArtisan: sourceLogoArtisans,
            sourceArtisan: 'currentArtisan.source',
          },
          { class: 'reduce' },
          { class: '', key: 'onSitePayment' },
          { class: '', list: status.data },
        ],
        keys: [
          'id',
          'login.ajout',
          'date.sstRappelAchat',
          'categorie',
          'date.ajout',
          [
            'client.civility',
            'client.name',
            'client.firstname',
            'client.society',
          ],
          ['client.address.zipcode', 'client.address.city'],
          'metierName',
          artisanKeys(user),
          'date.intervention',
          'announcedPrice',
          'status',
        ],
        checkType: [
          'number',
          'users',
          'date',
          'categorie',
          'date',
          ['client.civility', 'client.name', 'client.firstname'],
          ['client.address.city', 'client.address.zipcode'],
          'metierName',
          artisanKeys(user),
          'date',
          'prix',
          'iStatus',
        ],
      };
      return columns;
    }
    case S_JUR: {
      const columns = {
        table: {
          OS: Types.Text,
          Telepro: Types.Text,
          'Cat.': Types.Rectangle,
          Ajout: Types.Text,
          Client: Types.Text,
          Ville: Types.Text,
          Description: Types.StepMetierName,
          Artisan: Types.artisanRef,
          'Grand Compte': Types.nomGramdCompte,
          Prevu: Types.Date,
          Prix: Types.Money,
          iStatus: Types.Chip,
          rSST: Types.Chip,
          Appel: Types.Icon,
        },
        tableData: [
          { class: 'th' },
          { class: '', list: users, key: 'login' },
          { class: '', list: categories.data },
          { class: 'reduce' },
          { class: '' },
          { class: '', name: 'ville' },
          { class: '' },
          {
            class: 'th',
            name: 'artisan',
            list: [],
            key: 'currentArtisan.subStatus',
            status: aSubStatus.data,
            logoArtisan: sourceLogoArtisans,
            sourceArtisan: 'currentArtisan.source',
          },
          {
            class: 'th',
            name: 'grandCompte',
            list: [],
            key: 'billing.grandCompte',
          },
          { class: 'reduce' },
          { class: '', key: 'onSitePayment' },
          { class: '', list: status.data },
          {
            class: '',
            name: 'firstPaid',
            key: 'firstPaid',
            list: paidStatus,
          },
          { class: '' },
        ],
        keys: [
          'id',
          'login.ajout',
          'categorie',
          'date.ajout',
          [
            'client.civility',
            'client.name',
            'client.firstname',
            'client.society',
          ],
          ['client.address.zipcode', 'client.address.city'],
          'metierName',
          artisanKeys(user),
          'billing.companyName',
          'date.intervention',
          'announcedPrice',
          'status',
          'firstPaid',
          'appel',
        ],
        checkType: [
          'number',
          'users',
          'categorie',
          'date',
          ['client.civility', 'client.name', 'client.firstname'],
          ['client.address.city', 'client.address.zipcode'],
          'metierName',
          artisanKeys(user),
          'billing.companyName',
          'date',
          'prix',
          'iStatus',
          'number',
          'appel',
        ],
      };
      return columns;
    }
    default: {
      const columns = {
        table: {
          OS: Types.Text,
          Telepro: Types.Text,
          ...(user.service === S_INFO ? { Service: Types.ServiceName } : {}),
          'Cat.': Types.Rectangle,
          Ajout: Types.Text,
          Client: Types.Text,
          Ville: Types.Text,
          Description: Types.StepMetierName,
          Artisan: Types.artisanRef,
          Prevu: Types.Date,
          Prix: Types.Money,
          iStatus: Types.Chip,
          rSST: Types.Chip,
          Appel: Types.Icon,
        },
        tableData: [
          { class: 'th' },
          { class: '', list: users, key: 'login' },
          ...(user.service === S_INFO ? [{ class: '' }] : []),
          { class: '', list: categories.data },
          { class: 'reduce' },
          { class: '' },
          { class: '', name: 'ville' },
          { class: '' },
          {
            class: 'th',
            name: 'artisan',
            list: [],
            key: 'currentArtisan.subStatus',
            status: aSubStatus.data,
            logoArtisan: sourceLogoArtisans,
            sourceArtisan: 'currentArtisan.source',
          },
          { class: 'reduce' },
          { class: '', key: 'onSitePayment' },
          { class: '', list: status.data },
          {
            class: '',
            name: 'firstPaid',
            key: 'firstPaid',
            list: paidStatus,
          },
          { class: '' },
        ],
        keys: [
          'id',
          'login.ajout',
          ...(user.service === S_INFO ? ['service.desc'] : []),
          'categorie',
          'date.ajout',
          [
            'client.civility',
            'client.name',
            'client.firstname',
            'client.society',
          ],
          ['client.address.zipcode', 'client.address.city'],
          'metierName',
          artisanKeys(user),
          'date.intervention',
          'announcedPrice',
          'status',
          'firstPaid',
          'appel',
        ],
        checkType: [
          'number',
          'users',
          ...(user.service === S_INFO ? ['service'] : []),
          'categorie',
          'date',
          ['client.civility', 'client.name', 'client.firstname'],
          ['client.address.city', 'client.address.zipcode'],
          'metierName',
          artisanKeys(user),
          'date',
          'prix',
          'iStatus',
          'number',
          'appel',
        ],
      };
      return columns;
    }
  }
};
